<template>
  <!-- 商品订单详情 -->
  <div class="index-container">
    <div class="course-container">
      <div class="nav-box">
        首页 > 大健康人才培训 > 个人中心 > 我的课程
        <span>> 订单详情</span>
      </div>
      <personalSidebar>
        <div class="right-content" v-if="orderDetail">
          <div class="r-title">订单信息</div>
          <div class="flow-box">
            <template v-for="(item,index) in orderDetail.spread">
              <div
                class="flow-list"
                :key="'step' + index"
                :class="item.state === 1?'have-state':''"
              >
                <div class="icon-box" v-if="index == 0">
                  <i class="iconfont-icon icon-dingdan"></i>
                </div>
                <div class="icon-box" v-if="index == 1">
                  <i class="iconfont-icon icon-fukuanchenggong"></i>
                </div>
                <div class="icon-box" v-if="index == 2">
                  <i class="iconfont-icon icon-navicon-ckyw"></i>
                </div>
                <div class="icon-box" v-if="index == 3">
                  <i class="iconfont-icon icon-daifahuo"></i>
                </div>
                <div class="icon-box" v-if="index == 4">
                  <i class="iconfont-icon icon-wancheng"></i>
                </div>
                <div class="f-title">{{item.value}}</div>
                <div class="f-title">{{item.time}}</div>
              </div>
              <div
                class="flow-icon"
                :key="'state' + index"
                :class="item.state === 1?'have-state':''"
              >
                <i class="iconfont-icon icon-xuxian"></i>
                <i class="iconfont-icon icon-xuxian"></i>
              </div>
            </template>
          </div>
          <div class="address-box">
            <i class="iconfont el-icon-location-outline"></i>
            <div class="r-text">
              <div>{{orderDetail.receive_name}} {{orderDetail.receive_mobile}}</div>
              <div
                class="a-text"
              >{{orderDetail.province}} {{orderDetail.city}} {{orderDetail.area}} {{orderDetail.address}}</div>
            </div>
          </div>
          <div class="detail-box">
            <div class="confirm-btn" v-if="orderDetail.order_state !== 4 && orderDetail.order_state !== 3" @click="confirmRecevie">确认收货</div>
            <div class="top-box" v-for="(item,index) in orderDetail.goods" :key="index">
              <div class="img" :style="{ backgroundImage: 'url( ' + imgUrl + item['thumb']+ ')' }"></div>
              <div class="right-detail">
                <div class="d-title">{{item.goods_name}}</div>
                <div class="type-box">
                  <span>规格：</span>全集
                  <span class="num">数量：</span>
                  <i class="iconfont el-icon-close"></i>
                  {{item.goods_number}}
                </div>
              </div>
            </div>
            <div class="bottom-box">
              <div class="left-text">
                订单编号：{{orderDetail.order_id}}
                <span>下单时间：{{orderDetail.create_time}}</span>
              </div>
              <div class="price-box">
                实付款：
                <span>¥</span>
                <span class="price">{{orderDetail.order_amount}}</span>
                <template v-if="orderDetail.pay_type === 2">
                  <i class="iconfont-icon icon-weixinfukuan"></i>
                  <span class="pay-text">微信支付</span>
                </template>
                <template v-if="orderDetail.pay_type === 1">
                  <i class="iconfont-icon icon-zhifubao"></i>
                  <span class="pay-text">支付宝支付</span>
                </template>
                <template v-if="orderDetail.pay_type === 3">
                  <i class="iconfont-icon icon-duigongzhuanzhang"></i>
                  <span class="pay-text">对公打款</span>
                </template>
                <template v-if="orderDetail.pay_type === 4">
                  <i class="iconfont-icon icon-xianjinzhifu"></i>
                  <span class="pay-text">现金支付</span>
                </template>
              </div>
            </div>
          </div>
          <div class="r-title">物流进度</div>
          <div class="step-box">
            <div class="step-list" v-for="(item,index) in orderDetail.transport" :key="index">
              <div class="step-date">{{item.ftime}}</div>
              <div class="icon-box" v-if="item.status === '签收'">
                <i class="iconfont el-icon-success"></i>
              </div>
              <div class="icon-box" v-else-if="item.status === '派件'">
                <i class="iconfont-icon icon-paisongzhong"></i>
              </div>
              <div class="icon-box" v-else>
                <div class="circle"></div>
              </div>
              <div class="text-box">
                <div class="t-title">{{item.status}}</div>
                <div class="t-words">{{item.context}}</div>
              </div>
            </div>
            <!-- <div class="step-list">
              <div class="step-date">2021.12.13 15:23:45</div>
              <div class="icon-box">
                <i class="iconfont-icon icon-paisongzhong"></i>
              </div>
              <div class="text-box">
                <div class="t-title">派送中</div>
                <div class="t-words">[深圳市]广东省深圳市青龙路8号港之龙商务中心a座</div>
              </div>
            </div>
            <div class="step-list">
              <div class="step-date">2021.12.13 15:23:45</div>
              <div class="icon-box">
                <div class="circle"></div>
              </div>
              <div class="text-box">
                <div class="t-title">运输中</div>
                <div class="t-words">[深圳市]广东省深圳市青龙路8号港之龙商务中心a座</div>
              </div>
            </div>
            <div class="step-list">
              <div class="step-date">2021.12.13 15:23:45</div>
              <div class="icon-box">
                <div class="circle"></div>
              </div>
              <div class="text-box">
                <div class="t-title">运输中</div>
                <div class="t-words">[深圳市]广东省深圳市青龙路8号港之龙商务中心a座</div>
              </div>
            </div>
            <div class="step-list">
              <div class="step-date">2021.12.13 15:23:45</div>
              <div class="icon-box">
                <div class="circle"></div>
              </div>
              <div class="text-box">
                <div class="t-title">运输中</div>
                <div class="t-words">[深圳市]广东省深圳市青龙路8号港之龙商务中心a座</div>
              </div>
            </div>-->
          </div>
        </div>
      </personalSidebar>
    </div>
  </div>
</template>
<script>
import personalSidebar from '../components/personalSidebar.vue';
import api from '../api/api';
import { imgUrl } from '../api/index';

export default {
  name: 'orderDetail',
  components: {
    personalSidebar
  },
  data() {
    return {
      imgUrl: imgUrl,
      order_sn: '',
      orderDetail: {}
    };
  },
  mounted() {
    scrollTo(0, 0);
    const value = this.$route.query;
    if (value.order_sn) {
      this.order_sn = value.order_sn;
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      api.getOrderDetail({ order_sn: this.order_sn }).then(res => {
        console.log(res);
        if (res.result) {
          this.orderDetail = res.result;
        } else {
          this.$message.warning('暂无权限查看！');
        }
      });
    },
    // 确认收货
    confirmRecevie() {
      api.confirmRecevie({ order_sn: this.order_sn }).then(res => {
        if (res.result) {
          this.$message.warning('确认成功！');
          this.getDetail();
        } else {
          this.$message.warning('订单暂时无法确认收货！');
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  margin-top: 122PX;
  background-color: #f8f7f6;
}
.course-container {
  // width: 72%;
  padding: 50PX 0;
  margin: 0 auto;
}
.nav-box {
  width: 72%;
  margin: 0 auto;
  font-size: 16PX;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.index-content {
  display: flex;
  justify-content: space-between;
  min-height: 976PX;
}
.side-box {
  width: 26%;
  background-color: #ffffff;
}
.right-content {
  width: 72%;
  padding: 32PX 46PX;
  background-color: #ffffff;
  .r-title {
    padding-bottom: 20PX;
    font-size: 20PX;
    font-weight: bold;
    border-bottom: 1PX solid #ececec;
  }
}
.flow-box {
  display: flex;
  padding: 50PX 40PX 30PX;
  margin-bottom: 22PX;
  border-bottom: 10PX solid #f6f6f6;

  .have-state {
    color: #f1a373;
    .iconfont-icon {
      color: #f1a373;
    }
  }
  .iconfont-icon {
    font-size: 36PX;
    color: #a8a8a8;
    line-height: 37PX;
  }
  .icon-fukuanchenggong {
    font-size: 26PX;
  }
  .icon-navicon-ckyw {
    font-size: 32PX;
  }
  .icon-daifahuo {
    font-size: 38PX;
  }
  .icon-wancheng {
    font-size: 30PX;
    font-weight: bold;
  }
  .flow-list {
    // margin-right: 10PX;
    text-align: center;
  }
  .icon-box {
    padding-bottom: 18PX;
  }
  .f-title {
    width: 66PX;
    text-align: center;
  }
  .flow-icon {
    padding-left: 1PX;
    margin-left: 10PX;
    &:last-child {
      display: none;
    }
  }
}
.address-box {
  display: flex;
  align-items: center;
  padding: 0 26PX 50PX;
  .iconfont {
    font-size: 20PX;
    color: #222222;
    font-weight: bold;
  }
  .r-text {
    padding-left: 10PX;
    font-size: 18PX;
  }
  .a-text {
    color: #666666;
  }
}
.detail-box {
  position: relative;
  padding: 22PX 40PX 0 30PX;
  margin-bottom: 36PX;
  background-color: #f6f6f6;
  .top-box {
    display: flex;
    align-items: center;
    padding-bottom: 20PX;
    border-bottom: 1PX solid #ebebeb;
  }
  .img {
    width: 96PX;
    height: 96PX;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .right-detail {
    padding-left: 20PX;
  }
  .d-title {
    width: 68%;
    padding-bottom: 14PX;
    font-size: 18PX;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .type-box {
    span {
      color: #999999;
    }
    .num {
      padding-left: 16PX;
    }
  }
  .confirm-btn {
    position: absolute;
    top: 22PX;
    right: 40PX;
    width: 97PX;
    height: 34PX;
    color: #ffffff;
    text-align: center;
    line-height: 34PX;
    background: #f1a373;
    border-radius: 45PX;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .bottom-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14PX 0;
  }
  .left-text {
    color: #777777;
    span {
      padding-left: 20PX;
    }
  }
  .price-box {
    color: #999999;
    span {
      color: #dd0707;
      font-weight: bold;
    }
    .price {
      font-size: 22PX;
    }
    .iconfont-icon {
      padding-left: 22PX;
      color: #6bcc03;
    }
    .pay-text {
      color: #333333;
      font-weight: normal;
    }
  }
}
.step-box {
  padding: 30PX 44PX;
  .date-box {
    padding-right: 34PX;
  }
  .step-list {
    position: relative;
    display: flex;
    &:last-child {
      .text-box {
        border-left: none;
      }
    }
  }
  .step-date {
    width: 180PX;
    flex-shrink: 0;
    padding: 8PX 18PX 0 0;
  }
  .icon-box {
    position: absolute;
    top: -2PX;
    z-index: 9;
    left: 163PX;
    width: 34PX;
    background: #ffffff;
    border-radius: 50%;
    // margin-right: 25PX;
    // &::before {
    //   position: absolute;
    //   top: 32PX;
    //   right: 16PX;
    //   width: 1PX;
    //   height: 58PX;
    //   background-color: #c2c2c2;
    //   content: '';
    // }
  }
  .iconfont,
  .iconfont-icon {
    font-size: 34PX;
    color: #f1a475;
  }
  .circle {
    width: 12PX;
    height: 12PX;
    margin: 0 auto;
    background: #d8d8d8;
    border-radius: 50%;
  }
  .t-title {
    font-size: 18PX;
  }
  .text-box {
    flex: 1;
    padding: 0 0 50PX 25PX;
    border-left: 1PX solid #c2c2c2;
  }
  .t-words {
    padding-top: 4PX;
    color: #777777;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/orderDetail.vue